import PropTypes from 'prop-types';
import React from 'react'; // eslint-disable-line no-unused-vars
import FieldPropType from './field';
import FilePropType from './file';
import TaskPropType from './task';

const { arrayOf, bool, number, objectOf, oneOfType, shape, string } = PropTypes; // eslint-disable-line no-unused-vars

export default shape({
  category: string,
  completedCount: number,
  createdBy: string,
  deadlineWarning: string,
  description: string,
  displayName: string,
  endDate: string,
  eventID: string,
  fields: arrayOf(FieldPropType),
  files: arrayOf(FilePropType),
  isOverdue: bool,
  isTest: bool,
  overdueCount: number,
  owner: string,
  ownerEmail: string,
  ownerFullName: string,
  percentComplete: number,
  percentTimeElapsed: number,
  priority: string,
  processDisplayName: string,
  processID: string,
  progressSecret: string,
  runID: string,
  runningCount: number,
  skippedCount: number,
  startDate: string,
  status: string,
  taskCount: number,
  tasks: arrayOf(TaskPropType),
  teamName: string,
  waitingCount: number
});



// WEBPACK FOOTER //
// ./js/types/api/run.js